export const WEBHOOK_URL = "https://hooks.slack.com/services/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"